export default __webpack_public_path__ + "static/media/product-label-example.d7f6fdda.png";